// edit: zhangmyh 2017-9-8 4:50 PM
import { Get, URLs } from 'common'
import { find } from 'lodash'
/* global ko */

function areaSelect (params) {
  let locked = false
  this.selecting = ko.observable(false)
  this.type = 'in'// (params.type() == 5) ? 'out' : 'in'
  this.list = ko.observableArray([])
  this.index = ko.observable('province')
  this.step = ko.observable(0)
  this.provinceName = ko.observable('未选择')
  this.cityName = ko.observable('未选择')
  this.districtName = ko.observable('未选择')
  let rootList = []
  const t = this
  this.value = ko.pureComputed(function () {
    let text = ''
    let flag = params.province()
    if (flag && flag !== '') {
      text += t.provinceName()
    }
    flag = params.city()
    if (flag && flag !== '') {
      text += t.cityName()
    }
    flag = params.district()
    if (flag && flag !== '') {
      text += t.districtName()
    }
    return text
  })

  this.toggle = () => {
    let selecting = this.selecting()
    this.selecting(!selecting)
  }

  this.chooseProvince = () => {
    locked = true
    if (this.index() != 'province') {
      this.list(rootList)
      this.index('province')
    }
    locked = false
  }

  this.chooseCity = (province, name) => {
    if (this.index() == 'city') {
      return
    }
    if (locked) {
      return
    }
    if (!province || typeof province == 'object') {
      province = params.province()
    } else {
      params.province(province)
      this.provinceName(name)
      params.city(null)
      this.cityName('未选择')
      params.district(null)
      this.step(1)
    }

    let t = this
    locked = true
    Get(URLs.address_city.url, { province: province }).then(function (data, state) {
      if (state.toLowerCase() === 'success') {
        t.list(data.map(function (o) {
          return {
            id: o.cityID,
            text: o.cityName
          }
        }))
        t.index('city')
      }
      locked = false
    })
  }

  this.chooseDistrict = (city, name) => {
    if (this.index() == 'district') {
      return
    }
    if (locked) {
      return
    }
    if (!city || typeof city == 'object') {
      city = params.city()
    } else {
      params.city(city)
      this.cityName(name)
      params.district(null)
      this.districtName('未选择')
      this.step(2)
    }

    let t = this
    locked = true
    Get(URLs.address_district.url, { city: city }).then(function (data, state) {
      if (state.toLowerCase() === 'success') {
        t.list(data.map(function (o) {
          return {
            id: o.districtID,
            text: o.districtName
          }
        }))
        t.index('district')
      }
      locked = false
    })
  }

  this.confirm = (id, name) => {
    if (this.type == 'in') {
      params.district(id)
      this.districtName(name)
    }
    this.selecting(false)
  }

  this.changeArea = function (id, name) {
    const type = t.index()
    if (type == 'province') {
      this.chooseCity(id, name)
    } else if (type == 'city') {
      this.chooseDistrict(id, name)
    } else if (type == 'district') {
      this.confirm(id, name)
    }
  }

  if (this.type == 'in') {
    let district = params.district()
    let city = params.city()
    let province = params.province()

    if ((district && district !== '') || (city && city !== '')) {
      this.index('district')
      this.step(2)
      Get(URLs.address_district.url, { city: params.city() }).then(function (data, state) {
        if (state.toLowerCase() === 'success') {
          t.list(data.map(function (o) {
            return {
              id: o.districtID,
              text: o.districtName
            }
          }))
          if ((district && district !== '')) {
            let item = find(data, ['districtID', district])
            t.districtName(item.districtName)
          }
        }
      })
    }

    if (!city || city === '') {
      this.index('city')
      this.step(1)
    }

    if ((province && province !== '') || (city && city !== '')) {
      Get(URLs.address_city.url, { province: params.province() }).then(function (data, state) {
        if (state.toLowerCase() === 'success') {
          if (city && city !== '') {
            let item = find(data, ['cityID', city])
            t.cityName(item.cityName)
          } else {
            t.list(data.map(function (o) {
              return {
                id: o.cityID,
                text: o.cityName
              }
            }))
          }
        }
      })
    }

    if (!province || province === '') {
      this.index('province')
      this.step(0)
    }

    Get(URLs.address_province.url).then(function (data, state) {
      if (state.toLowerCase() === 'success') {
        let list = data.map(function (o) {
          return {
            id: o.provinceID,
            text: o.provinceName
          }
        })
        rootList = list
        if (province && province !== '') {
          let item = find(data, ['provinceID', province])
          t.provinceName(item.provinceName)
        } else {
          t.list(rootList)
        }
      }
    })
  }
}
export default areaSelect



// WEBPACK FOOTER //
// ./src/components/area-select/index.js